/* =========================

  which is name

============================ */
import styled from "styled-components";
import { useSelector } from "react-redux";
import sanitize from "sanitize-html";

import {break_point_sp} from "../../../Styled/mixin";
import Image from "../../../Components/Part/Image";
import ImageRetina from "../../../Components/Part/ImageRetina";

import Btn from "../part/Btn";


/* -------------------------

  component

---------------------------- */
function Recommend01( props ) {
  const state = useSelector((state)=>state.datasRecommendSet);

  let recommend01 ;
  state.map((s,i)=>(
    (props.flagment === s.flagName)?recommend01=s:""
  ))

  return (
    <Styled className="p-result__section_recommend01 p-result__section">

      <div className="p-result__section_recommend01__heading">
        <div className="p-result__section_recommend01__heading__inner">
          <h2>
            <ImageRetina
              type={"png"}
              src_pc_1x={"/assets/img/result/recommend01/title.png"}
              src_pc_2x={"/assets/img/result/recommend01/title@2x.png"}
              src_sp_1x={"/assets/img/result/recommend01/sp/title.png"}
              src_sp_2x={"/assets/img/result/recommend01/sp/title@2x.png"}
              alt={"今ならおトクに始めるチャンス！"}
            />
          </h2>
        </div>
      </div>

      <div className="p-result__section_recommend01__inner p-result__section__inner l-inner--1100">

        <div className="p-result__block_recommend01 p-result__block">
          <div className="p-result__block_recommend01__inner p-result__block__inner">

            <div className="p-result__box_recommend01 p-result__box l-box">
              <div className="p-result__box_recommend01__inner p-result__box__inner">

                <div className="p-result__box_recommend01__heading">
                  <div className="p-result__box_recommend01__heading__inner">
                    <h4>
                      <ImageRetina
                        type={"png"}
                        src_pc_1x={"/assets/img/result/recommend01/ballow_teiki.png"}
                        src_pc_2x={"/assets/img/result/recommend01/ballow_teiki@2x.png"}
                        src_sp_1x={"/assets/img/result/recommend01/sp/ballow_teiki.png"}
                        src_sp_2x={"/assets/img/result/recommend01/sp/ballow_teiki@2x.png"}
                        alt={"定期でおトクに続けたい！"}
                      />
                    </h4>
                  </div>
                </div>

                <div className="p-result__box_recommend01__part_top p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_top__inner">
                    <p className="p-result__box_recommend01__txt_title l-box__txt c-font_f--km">続けて試してみたい方に</p>
                    <div className="p-result__box_recommend01__part_top__part">
                      {/* <p className="p-result__box_recommend01__txt_catch l-box__txt c-font_f--km">定期購入率<span>98.6</span>%<sup>※</sup>！</p> */}
                      <p className="p-result__box_recommend01__txt_catch l-box__txt c-font_f--km" dangerouslySetInnerHTML={{__html:sanitize(recommend01.bodyCopy.teiki)}}></p>
                      <p className="p-result__box_recommend01__txt_notice l-box__txt">{recommend01.note.teiki}</p>
                    </div>
                  </div>
                </div>

                <div className="p-result__box_recommend01__part_middle p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_middle__inner">

                    <div className="p-result__box_recommend01__img l-box__img">
                      <Image
                        src={`/assets/img/result/products/${recommend01.flagName}_teiki.png`}
                        alt={recommend01.productName}
                      ></Image>
                    </div>

                    <p className="p-result__box_recommend01__txt_product_name l-box__txt">
                      {recommend01.productName}
                      <span>{recommend01.productSize.teiki}</span>
                    </p>
                    <p className="p-result__box_recommend01__txt_product_price_normal l-box__txt">1袋通常価格<span className="price">{recommend01.productPriceNormal.teiki}<span>円（税込）</span></span>を</p>
                    <p className="p-result__box_recommend01__txt_product_price l-box__txt">
                      <span className="tag">定期便で<br />ずっと10%OFF</span>
                      <span className="price">{recommend01.productPrice.teiki}<span>円（税込）</span></span>
                    </p>

                  </div>
                </div>

                <div className="p-result__box_recommend01__part_bottom p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_top__inner">
                    <Btn href={recommend01.linkAbout}>詳しく見てみる</Btn>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div className="p-result__block_recommend01 p-result__block">
          <div className="p-result__block_recommend01__inner p-result__block__inner">

            <div className="p-result__box_recommend01 p-result__box l-box">
              <div className="p-result__box_recommend01__inner p-result__box__inner">

                <div className="p-result__box_recommend01__heading">
                  <div className="p-result__box_recommend01__heading__inner">
                    <h4>
                      <ImageRetina
                        type={"png"}
                        src_pc_1x={"/assets/img/result/recommend01/ballow_bulk.png"}
                        src_pc_2x={"/assets/img/result/recommend01/ballow_bulk@2x.png"}
                        src_sp_1x={"/assets/img/result/recommend01/sp/ballow_bulk.png"}
                        src_sp_2x={"/assets/img/result/recommend01/sp/ballow_bulk@2x.png"}
                        alt={"定期でおトクに続けたい！"}
                      />
                    </h4>
                  </div>
                </div>

                <div className="p-result__box_recommend01__part_top p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_top__inner">
                    <p className="p-result__box_recommend01__txt_title c-font_f--km">続けて試してみたい方に</p>
                    <div className="p-result__box_recommend01__part_top__part">
                      <p className="p-result__box_recommend01__txt_catch__tag c-font_f--km">初回限定</p>
                      <p className="p-result__box_recommend01__txt_catch c-font_f--km"dangerouslySetInnerHTML={{__html:sanitize(recommend01.bodyCopy.bulk)}}></p>
                      <p className="p-result__box_recommend01__txt_notice">{recommend01.note.bulk}</p>
                    </div>
                  </div>
                </div>

                <div className="p-result__box_recommend01__part_middle p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_middle__inner">

                    <div className="p-result__box_recommend01__img l-box__img">
                    <Image
                      src={`/assets/img/result/products/${recommend01.flagName}_bulk.png`}
                      alt={recommend01.productName}
                    ></Image>
                    </div>

                    <p className="p-result__box_recommend01__txt_product_name l-box__txt">{recommend01.productName}<span>{recommend01.productSize.bulk}</span></p>
                    <p className="p-result__box_recommend01__txt_product_price_normal l-box__txt">1袋通常価格<span className="price">{recommend01.productPriceNormal.bulk}<span>円（税込）</span></span>を</p>
                    <p className="p-result__box_recommend01__txt_product_price l-box__txt">
                      特別価格
                      <span className="price">{recommend01.productPrice.bulk}<span>円（税込）</span></span>
                    </p>

                  </div>
                </div>

                <div className="p-result__box_recommend01__part_bottom p-result__part l-box__part">
                  <div className="p-result__box_recommend01__part_top__inner">
                    <Btn href={recommend01.linkAbout}>詳しく見てみる</Btn>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </Styled>
  );
}

export default Recommend01;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.section`
  background: #ffffff;
  padding: 45px 0 60px;

  .p-result__section_recommend01__inner{
    display: flex;
    justify-content: space-between;
  }

  .p-result__section_recommend01__heading{
    margin-bottom: 40px;
    .p-result__section_recommend01__heading__inner{
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .p-result__block_recommend01{
    width: 45%;
    .p-result__block__inner{
      /* height: 100%; */
    }
  }

  .p-result__box_recommend01{
    /* height: 100%; */
    .p-result__box__inner{
      display: flex;
      flex-direction: column;
      /* height: 100%; */
    }

    .p-result__box_recommend01__heading{
      margin-bottom: 20px;
    }

    .p-result__box_recommend01__part_top{
      text-align: center;
      line-height: 1.3;
    }

    .p-result__box_recommend01__part_middle{
      text-align: center;
      flex-grow: 1;
      .p-result__box_recommend01__part_middle__inner{
        display: flex;
        flex-direction: column;
        /* height: 100%; */
        .p-result__box_recommend01__txt_product_name{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-grow: 1;
        }
      }
    }

    .p-result__box_recommend01__part_bottom{
      width: 85%;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }

    .l-box__part{

      .p-result__box_recommend01__txt_title{
        font-size: 3.2rem;
        margin-bottom: 20px;
        &::before{
          content: "＼";
          display: inline-block;
        }
        &::after{
          content: "／";
          display: inline-block;
        }
      }

      .p-result__box_recommend01__part_top__part{
        display: inline-block;
        line-height: 1.3;
      }

      .p-result__box_recommend01__txt_catch__tag{
        display: inline-block;
        font-size: 3.2rem;
        color: #ed7200;
        background:linear-gradient(transparent 60%, #ff6 60%);
      }
      .p-result__box_recommend01__txt_catch{
        font-size: 3.2rem;
        color: #ed7200;
        margin-top: 0;
        span{
          font-size: 4.6rem;
          background:linear-gradient(transparent 60%, #ff6 60%);
        }
        sup{
          font-size: 14px;
          vertical-align: super;
        }
      }

      .p-result__box_recommend01__txt_notice{
        text-align: right;
        margin-top: 0;
      }

      .p-result__box_recommend01__img{
        text-align: center;
        width: 80%;
        margin-left: auto;
        margin-right: auto;
      }

      .p-result__box_recommend01__txt_product_name{
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        span{
          display: block;
          font-size: 20px;
        }
      }

      .p-result__box_recommend01__txt_product_price_normal{
        font-size: 20px;
        .price{
          font-size: 28px;
          font-weight: bold;
          position: relative;
          margin: 0 10px;
          span{
            font-size: 20px;
          }
          &::before{
            content: " ";
            display: inline-block;
            width: 60%;
            border-top: solid 4px #c40000;
            position: absolute;
            bottom: 0.5em;
            left: -0.3em;
            transform: rotateZ(-10deg);
          }
        }
      }

      .p-result__box_recommend01__txt_product_price{
        color: #c40000;
        font-weight: bold;
        font-size: 25px;
        margin-top: 0;
        .tag{
          display: inline-block;
          font-size: 17px;
          line-height: 1.3;
          padding: 5px 5px;
          border: solid 2px #c40000;
          border-radius: 5px;
          font-weight: normal;
          text-align: left;
        }
        .price{
          font-size: 39px;
          margin-left: 1em;
          span{
            font-size: 25px;
          }
        }
      }

    }
  }

	@media ${break_point_sp} {
    .p-result__section_recommend01__inner{
      display: block;
      padding: 0 4%;
    }

    .p-result__section_recommend01__heading{
      .p-result__section_recommend01__heading__inner{
        max-width: 92%;
      }
    }

    .p-result__block_recommend01{
      width: 100%;
      &+.p-result__block_recommend01{
        margin-top: 40px;
      }
    }

    .p-result__box_recommend01{
      /* .p-result__box_recommend01__part_top{
      } */

      /* .p-result__box_recommend01__part_middle{
      } */

      /* .p-result__box_recommend01__part_bottom{
      } */

      .l-box__part{

        .p-result__box_recommend01__txt_title{
          font-size: calc((50/750)*100vw);
          margin-bottom: 0;
        }

        /* .p-result__box_recommend01__part_top__part{
        } */

        .p-result__box_recommend01__txt_catch__tag{
          font-size: calc((45/750)*100vw);
        }
        .p-result__box_recommend01__txt_catch{
          font-size: calc((45/750)*100vw);
          span{
            font-size: calc((70/750)*100vw);
          }
          sup{
            font-size: calc((30/750)*100vw);
          }
        }

        .p-result__box_recommend01__txt_notice{
          margin-top: 10px;
        }

        .p-result__box_recommend01__img{
          width: 90%;
        }

        .p-result__box_recommend01__txt_product_name{
          font-size: calc((50/750)*100vw);
          span{
            font-size: calc((40/750)*100vw);
          }
        }

        .p-result__box_recommend01__txt_product_price_normal{
          font-size: calc((40/750)*100vw);
          .price{
            font-size: calc((50/750)*100vw);
            margin: 0 2%;
            span{
              font-size: calc((40/750)*100vw);
            }
          }
        }

        .p-result__box_recommend01__txt_product_price{
          font-size: calc((40/750)*100vw);
          .tag{
            font-size: calc((30/750)*100vw);
          }
          .price{
            font-size: calc((80/750)*100vw);
            margin-left: 4%;
            span{
              font-size: calc((40/750)*100vw);
            }
          }
        }

      }
    }

	}
`;
